// extracted by mini-css-extract-plugin
export default {"main":"styles_main__5k1oS","locationPicker":"styles_locationPicker__lACj0"};